<script>

import VTextField from 'vuetify/es5/components/VTextField/VTextField'

export const wrapperMixin = {
    props: {
        required: Boolean,
        showDetails: Boolean,
        clearable: {
            type: Boolean,
            default: true
        },
        vRules: {
            type: Array,
            default: () => []
        }
    },
    beforeCreate () {
        this.$delete(this.$options.props, 'hideDetails')
        this.$delete(this.$options.props, 'rules')
    },
    methods: {
        genLabel () {
            let label = VTextField.options.methods.genLabel.call(this)
            if (this.required && !!label) {
                label.children[0].text += '*'
            }
            return label
        }
    },
    computed: {
        hideDetails () {
            return !this.showDetails
        },
        rules () {
            return this.required ? [this.$utils.rules.required, ...this.vRules] : this.vRules
        }
    }
}

export default {
    name: 'TextField',
    extends: VTextField,
    mixins: [wrapperMixin]
}
</script>
